import { useEffect, useState } from 'react';
import { IMealCredit } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';
import { pushErrorFromAPI } from 'src/utilities/notifications';
import { fetchMealCreditDetails } from 'src/components/oneCorp/features/MealCredit/components/Form/hooks/fetchMealCreditDetailsApi';

export interface UseFetchMealCreditDetails {
  mealCredit: IMealCredit;
  fetchMealCredit: () => Promise<void>;
  isFetching: boolean;
}

export const useFetchMealCreditDetails = ({
  corpId,
  mealCreditId,
}: {
  corpId: string;
  mealCreditId: string;
}): UseFetchMealCreditDetails => {
  const [mealCredit, setMealCredit] = useState<IMealCredit>(null);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (corpId && mealCreditId) {
      fetchMealCredit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [corpId, mealCreditId]);

  async function fetchMealCredit(): Promise<void> {
    setIsFetching(true);
    try {
      const response: IMealCredit = await fetchMealCreditDetails({
        corpId,
        mealCreditId,
      });
      setMealCredit(response);
    } catch (error) {
      pushErrorFromAPI(error);
    } finally {
      setIsFetching(false);
    }
  }

  return { mealCredit, fetchMealCredit, isFetching };
};
